// Avis Google réels de la boutique (repris de TestimonialsSection).
// Source unique réutilisée par les bandes d'avis des pages de service.
export const REVIEWS = [
  { name: 'M. Rico', text: "Super expérience ! Venue pour un écran complètement noir, rien à redire. Très professionnel et de bons conseils." },
  { name: 'Alexandre Launes', text: "Magasin honnête : je pensais mon écran HS, c'était juste la nappe de connexion, ils me l'ont dit. Prix plus bas qu'ailleurs." },
  { name: 'Christophe Farque', text: "Gentillesse, professionnalisme, rapidité, explications claires et petits prix. Merci à l'équipe !" },
  { name: 'LIYIN WU', text: "Atelier vraiment professionnel, tarif concurrentiel et accueil sympathique. À chaque souci mobile ou PC ils m'ont dépannée. Je recommande." },
  { name: 'Victor Martin', text: "Très honnête : venu pour le tactile de mon téléphone, réparé gratuitement en 10 secondes alors qu'il aurait pu me faire payer." },
  { name: 'Corentin K.', text: "Étant moi-même réparateur, je constate un réel professionnalisme. Boutique sérieuse, équipe compétente, je recommande à 100 %." },
];

export const RATING = '4,7';
export const REVIEW_COUNT = '579';
